import mobilario from "../../../assets/img/ecomcategories/mobiliario.webp";
import banquete from "../../../assets/img/ecomcategories/banquete.webp";
import fotoyvideo from "../../../assets/img/ecomcategories/fotoyvideo.webp";
import lugares from "../../../assets/img/ecomcategories/lugares.webp";
import montajedemesa from "../../../assets/img/ecomcategories/montaje_mesa.webp";
import musica from "../../../assets/img/ecomcategories/musica-dj.webp";
import organizacionevento from "../../../assets/img/ecomcategories/organizacion-evento.webp";
import personaldeservicio from "../../../assets/img/ecomcategories/personal-servicio.webp";
import bebidas from "../../../assets/img/ecomcategories/bebidas.webp";
import decoracion from "../../../assets/img/ecomcategories/decoracion.webp";
import floreria from "../../../assets/img/ecomcategories/floreria.webp";
import entretenimiento from "../../../assets/img/ecomcategories/entretenimiento.webp";
import iluminacion from "../../../assets/img/ecomcategories/Iluminacion.webp";
import sonido from "../../../assets/img/ecomcategories/sonido.webp";
import transporte from "../../../assets/img/ecomcategories/transporte.webp";
import invitaciones from "../../../assets/img/ecomcategories/invitaciones.webp";
import vestidosytrajes from "../../../assets/img/ecomcategories/vestidosytrajes.webp";
import recuerdos from "../../../assets/img/ecomcategories/recuerdos.webp";
import Swiper from "../../base/Swiper";
import { SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css"; // Ensure you import Swiper styles
import { useNavigate } from "react-router-dom"; // will use to navigate user to search page when category is clicked

type Category = {
  label: string;
  image?: JSX.Element;
};

const categories: Category[] = [
  {
    label: "Mobiliario",
    image: (
      <img
        src={mobilario}
        alt="mobilario"
        style={{
          width: "70px",
          height: "70px",
        }}
      />
    ),
  },
  {
    label: "Banquete",

    image: <img src={banquete} style={{ width: "70px", height: "70px" }} />,
  },
  {
    label: "Foto & Video",

    image: <img src={fotoyvideo} style={{ width: "70px", height: "70px" }} />,
  },
  {
    label: "Lugares",

    image: <img src={lugares} style={{ width: "70px", height: "70px" }} />,
  },
  {
    label: "Montaje de Mesa",

    image: (
      <img src={montajedemesa}  style={{ width: "70px", height: "70px" }} />
    ),
  },
  {
    label: "Música",

    image: (
      <img src={musica}  style={{ width: "70px", height: "70px" }} />
    ),
  },
  {
    label: "Organización Evento",

    image: (
      <img
        src={organizacionevento}
        style={{ width: "70px", height: "70px" }}
      />
    ),
  },
  {
    label: "Personal de Servicio",

    image: (
      <img
        src={personaldeservicio}
        style={{ width: "70px", height: "70px" }}
      />
    ),
  },
  {
    label: "Bebidas",

    image: (
      <img
        src={bebidas}
        style={{ width: "70px", height: "70px" }}
      />
    ),
  },
  {
    label: "Decoración",

    image: (
      <img
        src={decoracion}
        style={{ width: "70px", height: "70px" }}
      />
    ),
  },
  {
    label: "Florería",

    image: (
      <img
        src={floreria}
        style={{ width: "70px", height: "70px" }}
      />
    ),
  },
  {
    label: "Entretenimiento",

    image: (
      <img
        src={entretenimiento}
        style={{ width: "70px", height: "70px" }}
      />
    ),
  },
  {
    label: "Iluminación",

    image: (
      <img
        src={iluminacion}
        style={{ width: "70px", height: "70px" }}
      />
    ),
  },
  {
    label: "Sonido",

    image: (
      <img
        src={sonido}
        style={{ width: "70px", height: "70px" }}
      />
    ),
  },
  {
    label: "Transporte",

    image: (
      <img
        src={transporte}
        style={{ width: "70px", height: "70px" }}
      />
    ),
  },
  {
    label: "Invitaciones",

    image: (
      <img
        src={invitaciones}
        style={{ width: "70px", height: "70px" }}
      />
    ),
  },
  {
    label: "Vestidos & Trajes",

    image: (
      <img
        src={vestidosytrajes}
        style={{ width: "70px", height: "70px" }}
      />
    ),
  },
  {
    label: "Recuerdos",

    image: (
      <img
        src={recuerdos}
        style={{ width: "70px", height: "70px" }}
      />
    ),
  },
];

const EcomCategoryNavs = () => {
  return (
    <div className="">
      <Swiper
        slidesPerView={10} // Adjust this number as needed
        spaceBetween={10}
        navigation
        navigationPosition={{ top: "35%" }}
        breakpoints={{
          0: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          450: {
            slidesPerView: 4,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 6,
            spaceBetween: 10,
          },
          1200: {
            slidesPerView: 10,
            spaceBetween: 10,
          },
        }}
      >
        {categories.map((category) => (
          <SwiperSlide key={category.label}>
            <EcomCategoryNavItem category={category} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

const EcomCategoryNavItem = ({ category }: { category: Category }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/home/searchpage?category=${encodeURIComponent(category.label)}`);
  };

  return (
    <div className="icon-nav-item mx-2">
      <div
        className=""
        style={{ textDecoration: "none", cursor: "pointer" }}
        onClick={handleClick}
      >
        <div className="cardBg py-2 px-0">{category.image}</div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: 40,
            marginTop: 5,
            marginBottom: 5,
          }}
        >
          <p style={{ margin: 0 }}>{category.label}</p>
        </div>
      </div>
    </div>
  );
};

export default EcomCategoryNavs;
